// client/utils/cardHelpers.js
// Shared helper-functions for ProjektCardBlock & ServiceCardBlock

export const clamp = (n, min, max) => Math.min(Math.max(n, min), max);

export const stop = (e) => {
  e.preventDefault?.();
  e.stopPropagation?.();
};

export const fmtCHDateTime = (d) => {
  try {
    if (!d) return null;
    const dt = d instanceof Date ? d : new Date(d);
    if (Number.isNaN(dt.getTime())) return null;
    const hasTime = dt.getHours() || dt.getMinutes() || dt.getSeconds();
    return hasTime
      ? new Intl.DateTimeFormat("de-CH", { dateStyle: "medium", timeStyle: "short" }).format(dt)
      : dt.toLocaleDateString("de-CH");
  } catch {
    return null;
  }
};

export const fmtCHDate = (d) => {
  try {
    if (!d) return null;
    const dt = d instanceof Date ? d : new Date(d);
    if (Number.isNaN(dt.getTime())) return null;
    return dt.toLocaleDateString("de-CH");
  } catch {
    return null;
  }
};

export const fmtDate = (d) => {
  try {
    if (!d) return "–";
    return new Date(d).toLocaleDateString("de-CH", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return "–";
  }
};

export const fmtDateTime = (d) => {
  try {
    if (!d) return "–";
    return new Date(d).toLocaleString("de-CH", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "–";
  }
};

export const sameDay = (a, b) =>
  !!a &&
  !!b &&
  a instanceof Date &&
  b instanceof Date &&
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

export const buildRangeLabel = (start, end) => {
  if (start && end) {
    if (sameDay(start, end)) return fmtCHDate(start);
    return `${fmtCHDate(start)} – ${fmtCHDate(end)}`;
  }
  if (start) return `ab ${fmtCHDate(start)}`;
  if (end) return `bis ${fmtCHDate(end)}`;
  return null;
};

export const formatMultiline = (str) =>
  String(str || "")
    .split(/\r?\n/)
    .map((s) => s.trim())
    .filter(Boolean)
    .join(", ");

export const toNum = (v) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

export const uniqNums = (arr) =>
  Array.from(new Set((arr || []).map(toNum).filter(Boolean)));
